/**
 * Subtrai um valor do valor atual.
 *
 * @param {number|string} x - Valor atual.
 * @param {number|string} y - Valor a ser subtraído.
 * @returns {number}
 */
export function subtract(x, y) {
  return Number(x) - Number(y);
}
